import { FilterModel } from '@/components/SearchFilter/FilterModel';
import { LocationInfo } from '@/components/SearchFilter/LocationInfo';
import { SortCriteria } from '../jobs/sortcriteria';

export class JobAlertConfigDetailsV2 {
  public textCriteria: string = '';
  public locationInfo: LocationInfo = new LocationInfo();
  public sortCriteria: SortCriteria = new SortCriteria();
  public jobParamRequests: FilterModel[] = [];
}
